<ion-app>
  <ng-container *ngIf="menuEnabled; else noMenu">
    <ion-split-pane when="md" contentId="main-content">
      <ion-menu contentId="main-content" type="overlay" [class.menu-collapsed]="isMenuCollapsed">
        <ion-header class="ion-no-border">
          <ion-toolbar>
            <div class="menu-profile-container" (click)="gotoProfile()">
              <ion-avatar>
                <img [src]="avatar.profile?.imageUrl || 'assets/default-avatar.png'" alt="Admin">
              </ion-avatar>
              <div class="profile-info" *ngIf="!isMenuCollapsed">
                <h2>{{ avatar.profile?.name || 'Administrator' }}</h2>
                <p>Dispatch System</p>
              </div>
            </div>
          </ion-toolbar>
        </ion-header>

        <ion-content>
          <div class="menu-scroll-container">
            <ion-list lines="none" class="main-menu-list">
              <ion-list-header *ngIf="!isMenuCollapsed">Navigation</ion-list-header>
              <ion-menu-toggle auto-hide="false" *ngFor="let p of appPages">
                <ion-item [routerLink]="[p.url]" routerDirection="root" routerLinkActive="selected" detail="false"
                  class="menu-item">
                  <ion-icon [name]="p.icon" slot="start" [color]="p.color"></ion-icon>
                  <ion-label *ngIf="!isMenuCollapsed">{{ p.title }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>

            <ion-list lines="none" class="session-list">
              <ion-list-header *ngIf="!isMenuCollapsed">Account</ion-list-header>
              <ion-menu-toggle auto-hide="false">
                <ion-item button (click)="themeService.toggleTheme()" detail="false" class="menu-item">
                  <ion-icon [name]="themeService.isDark ? 'sunny-outline' : 'moon-outline'" slot="start"></ion-icon>
                  <ion-label *ngIf="!isMenuCollapsed">{{ themeService.isDark ? 'Light Mode' : 'Dark Mode' }}</ion-label>
                </ion-item>
              </ion-menu-toggle>
              <ion-menu-toggle auto-hide="false">
                <ion-item button (click)="logout()" detail="false" class="menu-item logout-item">
                  <ion-icon name="log-out-outline" slot="start" color="danger"></ion-icon>
                  <ion-label *ngIf="!isMenuCollapsed">Logout</ion-label>
                </ion-item>
              </ion-menu-toggle>
            </ion-list>
          </div>
        </ion-content>

        <ion-footer class="ion-no-border" *ngIf="!isMenuCollapsed">
          <ion-toolbar>
            <div class="version-tag">Version 1.0.8</div>
          </ion-toolbar>
        </ion-footer>
      </ion-menu>

      <div class="ion-page" id="main-content">
        <!-- PWA Install Banner (Global for Admin) -->
        <div *ngIf="pwaService.showInstallPromotion$ | async" class="pwa-install-banner"
          (click)="pwaService.installPwa()">
          <ion-icon name="download-outline"></ion-icon>
          <div class="pwa-text">
            <strong>{{ 'PWA.INSTALL_TITLE' | translate }}</strong>
            <p>{{ 'PWA.INSTALL_DESC' | translate }}</p>
          </div>
          <div class="pwa-action">Install</div>
        </div>

        <ion-router-outlet></ion-router-outlet>
      </div>
    </ion-split-pane>
  </ng-container>

  <ng-template #noMenu>
    <ion-router-outlet></ion-router-outlet>
  </ng-template>
</ion-app>